export default {
    SET_LOADING_STATE: "overtime/SET_LOADING_STATE",
    SET_OT_CALCULATION_DATA: "overtime/SET_OT_CALCULATION_DATA",
    SET_OT_CALCULATION_UPDATE_DATA: "overtime/SET_OT_CALCULATION_UPDATE_DATA",
    UPDATE_OT_CALCULATION_DATA: "overtime/UPDATE_OT_CALCULATION_DATA",
};
